const Alert = ({ message }) => {
  return (
    <div className="d-flex justify-content-center mt-5">
      <div className="alert alert-danger w-75 text-center" role="alert">
        {message}
      </div>
    </div>
  );
};

export default Alert;
